import { PayinPaymentMethod } from '~/entities/payin';

export const isSupportedPaymentMethod = (
    method?: PayinPaymentMethod,
): method is PayinPaymentMethod.METHOD_SBP | PayinPaymentMethod.METHOD_CARD => {
    return method === PayinPaymentMethod.METHOD_SBP || method === PayinPaymentMethod.METHOD_CARD;
};
